var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileUserIconStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99967 3.75325L7.64634 5.27992L7.95967 6.01992L8.75968 6.08659L10.4063 6.22659L9.15301 7.31325L8.54634 7.83992L8.72634 8.62659L9.09967 10.2333L7.68634 9.37992L6.99967 8.95325L6.31301 9.36659L4.89967 10.2199L5.27301 8.61325L5.45301 7.82659L4.84634 7.29992L3.59301 6.21325L5.23967 6.07325L6.03967 6.00659L6.35301 5.26659L6.99967 3.75325ZM6.99967 0.333252L5.12634 4.75325L0.333008 5.15992L3.97301 8.31325L2.87967 12.9999L6.99967 10.5133L11.1197 12.9999L10.0263 8.31325L13.6663 5.15992L8.87301 4.75325L6.99967 0.333252Z",
    fill: "#F9C521"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUserIconStar);
export default __webpack_public_path__ + "static/media/ProfileUserIconStar.a77616bf119491e8e870a79cae073724.svg";
export { ForwardRef as ReactComponent };